export default __webpack_public_path__ + "static/media/user-05.432c81ea.jpg";